import type { CSSProperties } from "react";

export interface SwooshCurveProps {
  /** Extra classes for the SVG (e.g. `size-full` to fill the parent). */
  className?: string;
  /** Inline styles — typically `color` to drive the `currentColor` stroke. */
  style?: CSSProperties;
}

/**
 * Bare single-curve swoosh SVG. Stretches to fill its box (`preserveAspectRatio="none"`)
 * and strokes in `currentColor`, so callers set the tint via a text-color class or the
 * `color` style. Decorative — parents own positioning, sizing, and z-ordering.
 */
export function SwooshCurve({ className, style }: SwooshCurveProps) {
  return (
    <svg
      className={`block${className ? ` ${className}` : ""}`}
      fill="none"
      preserveAspectRatio="none"
      role="none"
      style={style}
      viewBox="0 0 392 140"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M419 81.2742C342.586 18.4569 264.878 34.7806 196.255 80.7072C127.631 126.634 36.5927 98.1591 -16 51.382"
        stroke="currentColor"
        strokeWidth="37.2459"
      />
    </svg>
  );
}
